import styled from '@emotion/styled';
import { darkTheme } from '../../../../theme';

export const VerificationBox = styled.div`
  background: #1e1f22;
  box-shadow: 0px 1px 3px 0px #10243e14;
  border-radius: 8px;
  max-width: 344px;
  min-height: 344px;
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const EmailIcon = styled.img`
  width: auto;
  height: 27px;
`;

export const InstructionText = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
  margin: 0;
`;

export const VerifyButton = styled.button`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 0;
  height: 48px;
  border: none;
  border-radius: 4px;
  background: #5e84ed;
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.2s ease;
  font-size: 16px;
  border-radius: 9px;
  border: 1px solid ${darkTheme.colors.primary};
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
`;

export const Input = styled.input`
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.secondary}; /* Inter */
  padding: 8px;
  border: 1px solid #5E84ED;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.inputBackground};
  height: 48px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 14px;
  text-align: left;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: #5E84ED;
    /* optional: add a subtle glow */
    box-shadow: 0 0 0 3px rgba(128, 151, 234, 0.5);
`;

export const ResendLink = styled.a`
  margin-top: 0px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  text-align: center;
  color: #5e84ed;
  height: 48px;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #2b2d33;
  justify-content: center;
  text-align: center;
`;

export const TimerText = styled.p`
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: Inter;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  text-align: center;
  color: #6f7a8c;
`;

export const ErrorText = styled.p`
  margin-top: 0px;
  margin-bottom: 0px;
  color: #d93025; /* red */
  font-family: Inter;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  text-align: center;
`;
